import { createAction, props } from '@ngrx/store';
import { User } from '@emm/core/models/user.model';

export enum AuthAction {
    AuthenticateUser = '[App Component] Authenticate User',
    AuthenticateUserFailure = '[Auth Api] Authenticate User Failure',
    AuthenticateUserSuccess = '[Auth Api] Authenticate User Success',
    SignOut = '[App Page] Sign Out',
}

export const AuthActions = {
    authenticateUser: createAction(AuthAction.AuthenticateUser),
    authenticateUserFailure: createAction(AuthAction.AuthenticateUserFailure, props<{ error: any }>()),
    authenticateUserSuccess: createAction(AuthAction.AuthenticateUserSuccess, props<{ user: User }>()),
    signOut: createAction(AuthAction.SignOut)
};
